import { AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const Blocked = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
            <AlertTriangle className="w-6 h-6 text-destructive" />
          </div>
          <CardTitle className="text-2xl">🚫 Website Temporarily Unavailable</CardTitle>
          <CardDescription className="text-base mt-2">
            This website is currently unavailable. Please contact the administrator to restore access.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-muted-foreground">
          Please contact the website administrator to restore access.
        </CardContent>
      </Card>
    </div>
  );
};

export default Blocked;
